const global = window

// Requête
inputs.behavior.query = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.query) {
        const apiForm = input.closest('[data-api]')
        const apiFormData = apiForm.data('data')
        input.click(function(event) {
            if (input.data('hold') || input.hasClass('cell--open')) return;
            callAPI(data.query.method, data.query.url, data.query.data, function (subdata) {
                if (event.type === 'click') {
                    if (input.hasClass('cell')) return;

                    if (parent && parent.closeWindow) parent.closeWindow();
                    inputWindow.find('input, select, textarea').filter(':visible').val('').change();
                    if (apiFormData && apiFormData.ajax) {
                        if (data.query.reload !== false) apiFormData.reload();
                    }
                    else {
                        if (data.query.reload === true) inputReloadParent(input)
                    }
                }
            }, function(data) {
                if (data.responseJSON && data.responseJSON.message) {
                    alert(data.responseJSON.message);
                }
            });
        })
    }
    return data
}
